import {
  USER_BADGE_ACTION_STARTS,
  USER_BADGE_ACTION_ERRORS,
  GET_USER_BADGES,
  ASSIGN_BADGE_TO_USER,
  UPDATE_USER_BADGE,
  DELETE_USER_BADGE,
} from './actions';

const initialState = {
  userBadges: [],
  loading: false,
  error: null,
};

const userBadgeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_BADGE_ACTION_STARTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case USER_BADGE_ACTION_ERRORS:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_USER_BADGES:
      return {
        ...state,
        loading: false,
        userBadges: action.payload,
        error: null,
      };
    case ASSIGN_BADGE_TO_USER:
      return {
        ...state,
        loading: false,
        userBadges: [action.payload, ...state.userBadges],
        error: null,
      };
    case UPDATE_USER_BADGE:
      return {
        ...state,
        loading: false,
        userBadges: state.userBadges.map((userBadge: any) =>
          userBadge.id === action.payload.id ? action.payload : userBadge
        ),
        error: null,
      };
    case DELETE_USER_BADGE:
      return {
        ...state,
        loading: false,
        userBadges: state.userBadges.filter((userBadge: any) => userBadge.id !== action.payload),
        error: null,
      };
    default:
      return state;
  }
};

export default userBadgeReducer;
